import { Component, Input } from '@angular/core';
import { DEFAULT_STYLE_OPTIONS } from '../../../constants/default-style-options';

@Component({
    selector: 'aumico-annualReport-complementary-report-swiss-display-component',
    templateUrl: 'complementary-report-swiss-display.component.html',
    styleUrls: ['complementary-report-swiss-display.component.scss'],
})
export class ComplementaryReportSwissDisplayComponent {
    @Input() complementaryReportContent: string;
    @Input() backgroundColor: string = DEFAULT_STYLE_OPTIONS.backgroundColor;
    @Input() textColor = DEFAULT_STYLE_OPTIONS.textColor;

}
